/**
 * granel-drawer-toggle.js — Auditoría 2026-05-02
 *
 * Cambios respecto al original:
 * 1. NO bloquea la navegación al hacer clic en el LINK con submenú.
 *    Inserta un BOTÓN chevron al lado para toggle del acordeón.
 *    El usuario puede tocar el texto para navegar, o el chevron para expandir.
 * 2. Soporte teclado: Enter / Space sobre el chevron.
 * 3. aria-expanded en el botón.
 *
 * Si prefieres mantener el comportamiento original (clic en cualquier parte = toggle),
 * descomenta el bloque "MODO LEGACY" al final.
 */
(function () {
  'use strict';

  var TOGGLE_BTN_CLASS = 'drawer-chevron-toggle';

  function ensureToggleButton(li) {
    if (!li || li.querySelector('.' + TOGGLE_BTN_CLASS)) return;
    var link = li.querySelector('.menu-drawer__menu-item--mainlist');
    var childlist = li.querySelector('.menu-drawer__menu--childlist');
    if (!link || !childlist) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = TOGGLE_BTN_CLASS;
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-label', 'Expandir submenú');
    btn.innerHTML = '<span aria-hidden="true">▾</span>';
    Object.assign(btn.style, {
      background: 'transparent',
      border: 'none',
      padding: '8px 12px',
      cursor: 'pointer',
      fontSize: '1rem',
      lineHeight: '1',
      color: 'inherit',
      verticalAlign: 'middle',
      marginLeft: '4px'
    });

    link.insertAdjacentElement('afterend', btn);
  }

  function initAllDrawers() {
    document.querySelectorAll('.menu-drawer .menu-drawer__list-item--flat').forEach(ensureToggleButton);
  }

  function toggleSubmenu(li, btn) {
    if (!li || !btn) return;
    var isOpen = li.classList.contains('drawer-submenu-open');

    var drawer = li.closest('.menu-drawer');
    if (drawer) {
      drawer.querySelectorAll('.menu-drawer__list-item--flat.drawer-submenu-open').forEach(function (other) {
        if (other !== li) {
          other.classList.remove('drawer-submenu-open');
          var otherBtn = other.querySelector('.' + TOGGLE_BTN_CLASS);
          if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    li.classList.toggle('drawer-submenu-open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.' + TOGGLE_BTN_CLASS);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var li = btn.closest('.menu-drawer__list-item--flat');
    toggleSubmenu(li, btn);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var btn = e.target.closest('.' + TOGGLE_BTN_CLASS);
    if (!btn) return;
    e.preventDefault();
    var li = btn.closest('.menu-drawer__list-item--flat');
    toggleSubmenu(li, btn);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllDrawers);
  } else {
    initAllDrawers();
  }

  document.addEventListener('shopify:section:load', initAllDrawers);

  /* ─── MODO LEGACY (comportamiento original que bloqueaba navegación)
     Si prefieres que TODO el link toggle el acordeón, comenta lo de arriba
     y descomenta esto:

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.menu-drawer__menu-item--mainlist');
    if (!link) return;
    var li = link.closest('.menu-drawer__list-item--flat');
    if (!li) return;
    var childlist = li.querySelector('.menu-drawer__menu--childlist');
    if (!childlist) return;
    e.preventDefault();
    e.stopPropagation();
    li.classList.toggle('drawer-submenu-open');
  }, true);
  ──────────────────────────────────────────────────────────────────── */
})();
